import React, { useState } from "react";
import "../../Style/PropertyDetail/FAQ.css";
import { FaChevronDown } from "react-icons/fa6";

const PropertyFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(0); // Set first active by default
  const [showAll, setShowAll] = useState(false); // Add Load More state

  const list = [
    {
      question: "Where can I buy an apartment in Sydney?",
      answer: "Henneberry Property Group has Sydney apartments for sale with Di Henneberry offering professional advice to buyers, investors and families seeking apartments in Sydney and New South Wales."
    },
    {
      question: "Is Henneberry Property Group a real estate agency?",
      answer: "Henneberry Property Group is a real estate agency providing a professional and personalized service to property buyers, sellers, landlords, tenants and investors in Sydney."
    },
    {
      question: "Will you assist me in finding a Sydney apartment for sale?",
      answer: "Certainly, we assist buyers in finding Sydney apartments for sale based on their lifestyle, budget, preferred location, and investment goals. Our guidance helps you compare property options, understand market value, and make a confident buying decision."
    },
    {
      question: "Will you help me find Sydney rental properties?",
      answer: "Yes, we assist both tenants and landlords in Sydney rental properties. Whether you need a home to lease or help leasing your property, Di Henneberry offers rental assistance."
    },
    {
      question: "What is the best website for house rentals in Sydney?",
      answer: "The best website for house rentals is one that offers trusted listings, clear property details and professional support. Henneberry Property Group helps tenants explore quality rental properties with expert guidance."
    },
    {
      question: "Can you help me find furnished houses for rent near me?",
      answer: "Yes, we can assist clients searching for furnished houses for rent near me by helping them explore available furnished homes, executive rentals and rental options suited to their needs."
    },
    {
      question: "Do you offer services like property management agencies?",
      answer: "Yes, Henneberry Property Group offers professional services similar to trusted property management agencies, including leasing support, tenant communication, property care and rental strategy."
    },
    {
      question: "Do you help clients find luxury house rentals?",
      answer: "Yes, we help clients find luxury house rentals throughout Sydney and New South Wales, including premium homes, executive residences and quality properties in desirable locations."
    },
    {
      question: "Can you help clients rent house Australia?",
      answer: "Yes, if you want to rent house Australia, Di Henneberry can guide you through suitable rental options and help you find a home that matches your needs."
    },
    {
      question: "Do you help clients find Sydney rental apartments?",
      answer: "Yes, we help clients find Sydney rental apartments, including modern apartments, executive rentals and lifestyle-focused apartments across popular Sydney suburbs."
    }
  ];

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const displayedList = showAll ? list : list.slice(0, 5);

  return (
    <div id="faq" className="faq">
      <div className="container-xxl p-0">
        <div className="faq-pill-wrapper">
          <span className="faq-pill">FAQ</span>
        </div>
        <h2 className="faqh2">Frequently Asked Questions</h2>
        <p className="faq-subtitle">
         Find clear answers to common questions about Sydney apartments, rental homes, and property management services.
        </p>
        
        <div className="faq-list">
          {displayedList.map((item, index) => {
            const isOpen = activeIndex === index;
            return (
              <div key={index} className={`faq-item ${isOpen ? "active" : ""}`}>
                <div className="faq-header" onClick={() => toggleFaq(index)}>
                  <h5 className="faq-question">{item.question}</h5>
                  <div className="faq-icon-wrapper">
                    <FaChevronDown className={`faq-icon ${isOpen ? "open" : ""}`} />
                  </div>
                </div>
                <div className="faq-answer-wrapper">
                  <div className="faq-answer-content">
                    <div className="faq-answer" dangerouslySetInnerHTML={{ __html: item.answer }} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="faq-load-more-container">
          <button className="faq-load-more-btn" onClick={() => setShowAll(!showAll)}>
            {showAll ? "Show Less" : "Load More"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PropertyFAQ;
